/* eslint-disable @wordpress/no-unsafe-wp-apis */
/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import {
  InspectorControls,
} from '@wordpress/block-editor';
import {
  PanelBody,
  TextControl,
  Button,
  __experimentalElevation as Elevation,
} from '@wordpress/components';
import {
  Fragment, useContext, useMemo
} from '@wordpress/element';
import { applyFilters } from '@wordpress/hooks';
import { decodeEntities } from '@wordpress/html-entities';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import 'react-datepicker/dist/react-datepicker.css';
import BlockContext from '../../blocks/wp-cv-builder/context/blockContext.js';
import JoditEditor from 'jodit-react';
import DatePicker from 'react-datepicker';
/**
 * Internal dependencies
 */

import * as Controls from '../../controls';
import * as Constants from '../../../src/blocks/wp-cv-builder/constants/index.js';

import '../../blocks/wp-cv-builder/editor.scss';
import SelectStyle from '../../options/selected-style.js';
import AdminSelectedStyle from '../../options/admin-selected-style.js';
import signatureImageUrl from '../../../includes/assets/img/sign-white.png';
import AIContent from '../../controls/AIContent';
import objAttributes from '../../blocks/wp-cv-builder/attributes.js';

// All Controls Import here
import AboutControl from '../../blocks/wp-cv-builder/InspectorControls/About.js';
import ContactControl from '../../blocks/wp-cv-builder/InspectorControls/Contact.js';
import ProfileControl from '../../blocks/wp-cv-builder/InspectorControls/Profile.js';
import SkillsControl from '../../blocks/wp-cv-builder/InspectorControls/Skills.js';
import LanguagesControl from '../../blocks/wp-cv-builder/InspectorControls/Languages.js';
import HobbiesControl from '../../blocks/wp-cv-builder/InspectorControls/Hobbies.js';
import EducationControl from '../../blocks/wp-cv-builder/InspectorControls/Education.js';
import ExperienceControl from '../../blocks/wp-cv-builder/InspectorControls/Experience.js';
import ReferenceControl from '../../blocks/wp-cv-builder/InspectorControls/Reference.js';
import AwardControl from '../../blocks/wp-cv-builder/InspectorControls/Award.js';
import ToolsControl from '../../blocks/wp-cv-builder/InspectorControls/Tools.js';
import AddSection from '../../blocks/wp-cv-builder/InspectorControls/AddSection.js';
import FooterControl from '../../blocks/wp-cv-builder/InspectorControls/Footer.js';





const Inspector = () => {
  const { attributes, setAttributes, emailPhoneVisibility } = useContext(BlockContext);
  const {
    style,
    images,
    footerPanel,
    isFooterVisible,
    footerLink,
    signature,
    footerBtnText,
    footerBtnLink,
    sectionItems,
    sectionItems2,
    sectionItems3,
    sectionItems4,
    sectionItems5,
    sectionItems6,
    sectionItems7,
    sectionItems8,
    sectionItems9,
    sectionItems10,
    sectionItems11,
    sectionItems12,
    sectionItems13,
    sectionItems14,
    sectionItems15,
    sectionItems16,
    sectionItems17,
    sectionItems18,
    sectionItems19,
    sectionItems20,
    sectionItems21,
    sectionItems22,
    sectionItems23,
    sectionItems24,
    sectionItems25,
    sectionItems26,
    sectionItems27,
    sectionItems28,
    sectionItems1,
    themeColor,
    typography,
    headerBackgroundColor,
    footerBgColor,
    bodyBgColor,
    leftColumnBgColor,
    rightColumnBgColor,
    userNameColor,
    designationColor,
    iconColor,
    iconBackgroundColor,
    aboutDateOfBirthColor,
    aboutNationalityColor,
    aboutTitleColor,
    aboutTitleBgColor,
    aboutTitleIconColor,
    aboutDescriptionColor,
    aboutDescColor,
    addressColor,
    contactTitleColor,
    contactTitleBgColor,
    contactTitleIconColor,
    skillTitleColor,
    skillTitleIconColor,
    skillTitleBgColor,
    skillNameColor,
    skillPercentageColor,
    skillTopBgColor,
    skillBottomBgColor,
    languageTitleColor,
    languageTitleIconColor,
    languageTitleBgColor,
    languageNameColor,
    languagePercentageColor,
    languageTopBgColor,
    languageBottomBgColor,
    hobbyTitleColor,
    hobbyTitleIconColor,
    hobbyTitleBgColor,
    hobbyNameColor,
    hobbyIconColor,
    educationTitleColor,
    educationTitleIconColor,
    educationTitleBgColor,
    studyFieldColor,
    institutionNameColor,
    degreeNameColor,
    educationDescriptionColor,
    educationPassingDateColor,
    experienceDateColor,
    experienceTitleColor,
    experienceTitleIconColor,
    experienceTitleBgColor,
    companyNameColor,
    experienceDescriptionColor,
    experienceDesignationColor,
    referenceTitleColor,
    referenceTitleIconColor,
    referenceTitleBgColor,
    referenceNameColor,
    referenceJobPositionColor,
    referenceCompanyColor,
    referencePhoneColor,
    referenceRelationColor,
    userNameTypography,
    designationTypography,
    aboutTitleTypography,
    aboutDescriptionTypography,
    sectionCountOne,
    sectionCountTwo,
    sectionCountThree,
    sectionCountFour,
    sectionCountFive,
    sectionCountSix,
    sectionCountSeven,
    sectionCountEight,
    sectionCountNine,
    sectionCountTen,
    sectionCountEleven,
    sectionCountTwelve,
    sectionCountThirteen,
    sectionCountFourteen,
    sectionCountFifteen,
    sectionCountSixteen,
    sectionCountSeventeen,
    sectionCountEighteen,
    sectionCountNineteen,
    sectionCountTwenty,
    sectionCountTwentyOne,
    sectionCountTwentyTwo,
    sectionCountTwentyThree,
    sectionCountTwentyFour,
    sectionCountTwentyFive,
    deletedSectionsData
  } = attributes;

  const objAttrs = { attributes, setAttributes, objAttributes };
  const {
    NAME_FONT_SIZE,
    DESIGNATION_FONT_SIZE,
    IMAGE_SIZE,
    IMAGE_BORDER_RADIUS,
    ICON_BORDER_RADIUS,
    ICON_SIZE,
    ICON_GAP,
    ICON_ROUND_SIZE,
    QR_POSITION_HORIZONTAL,
    QR_POSITION_VERTICAL,
    ABOUT_TITLE_FONT_SIZE,
    ABOUT_TITLE_ICON_FONT_SIZE,
    ABOUT_DESCRIPTION_FONT_SIZE,
    DATE_OF_BIRTH_FONT_SIZE,
    NATIONALITY_FONT_SIZE,
    CONTACT_FONT_SIZE,
    SKILL_TITLE_FONT_SIZE,
    SKILL_TITLE_ICON_FONT_SIZE,
    SKILL_NAME_FONT_SIZE,
    SKILL_PERCENTAGE_FONT_SIZE,
    LANGUAGE_TITLE_FONT_SIZE,
    LANGUAGE_TITLE_ICON_FONT_SIZE,
    LANGUAGE_NAME_FONT_SIZE,
    LANGUAGE_PERCENTAGE_FONT_SIZE,
    HOBBY_TITLE_FONT_SIZE,
    HOBBY_TITLE_ICON_FONT_SIZE,
    HOBBY_NAME_FONT_SIZE,
    HOBBY_ICON_FONT_SIZE,
    HOBBY_ITEM_GAP,
    EDUCATION_TITLE_FONT_SIZE,
    EDUCATION_TITLE_ICON_FONT_SIZE,
    EDUCATION_PASSING_YEAR_FONT_SIZE,
    INSTITUTION_CITY_COUNTRY_NAME_FONT_SIZE,
    STUDY_FIELD_FONT_SIZE,
    EDUCATION_DEGREE_NAME_FONT_SIZE,
    EDUCATION_DESCRIPTION_FONT_SIZE,
    EXPERIENCE_TITLE_FONT_SIZE,
    EXPERIENCE_TITLE_ICON_FONT_SIZE,
    EXPERIENCE_COMPANY_FONT_SIZE,
    EXPERIENCE_DESIGNATION_FONT_SIZE,
    EXPERIENCE_DESCRIPTION_FONT_SIZE,
    EXPERIENCE_DATE_FONT_SIZE,
    REFERENCE_TITLE_FONT_SIZE,
    REFERENCE_TITLE_ICON_FONT_SIZE,
    REFERENCE_NAME_FONT_SIZE,
    REFERENCE_JOB_POSITION_FONT_SIZE,
    REFERENCE_COMPANY_FONT_SIZE,
    REFERENCE_PHONE_FONT_SIZE,
    REFERENCE_RELATION_FONT_SIZE,
    ABOUT_PADDING_TOP,
    ABOUT_PADDING_RIGHT,
    ABOUT_PADDING_BOTTOM,
    ABOUT_PADDING_LEFT,
    ABOUT_BORDER_RADIUS_TOP,
    ABOUT_BORDER_RADIUS_RIGHT,
    ABOUT_BORDER_RADIUS_BOTTOM,
    ABOUT_BORDER_RADIUS_LEFT,
    CONTACT_PADDING_TOP,
    CONTACT_PADDING_RIGHT,
    CONTACT_PADDING_BOTTOM,
    CONTACT_PADDING_LEFT,
    CONTACT_BORDER_RADIUS_TOP,
    CONTACT_BORDER_RADIUS_RIGHT,
    CONTACT_BORDER_RADIUS_BOTTOM,
    CONTACT_BORDER_RADIUS_LEFT,
    SKILL_PADDING_TOP,
    SKILL_PADDING_RIGHT,
    SKILL_PADDING_BOTTOM,
    SKILL_PADDING_LEFT,
    SKILL_BORDER_RADIUS_TOP,
    SKILL_BORDER_RADIUS_RIGHT,
    SKILL_BORDER_RADIUS_BOTTOM,
    SKILL_BORDER_RADIUS_LEFT,
    LANGUAGE_PADDING_TOP,
    LANGUAGE_PADDING_RIGHT,
    LANGUAGE_PADDING_BOTTOM,
    LANGUAGE_PADDING_LEFT,
    LANGUAGE_BORDER_RADIUS_TOP,
    LANGUAGE_BORDER_RADIUS_RIGHT,
    LANGUAGE_BORDER_RADIUS_BOTTOM,
    LANGUAGE_BORDER_RADIUS_LEFT,
    HOBBY_PADDING_TOP,
    HOBBY_PADDING_RIGHT,
    HOBBY_PADDING_BOTTOM,
    HOBBY_PADDING_LEFT,
    HOBBY_BORDER_RADIUS_TOP,
    HOBBY_BORDER_RADIUS_RIGHT,
    HOBBY_BORDER_RADIUS_BOTTOM,
    HOBBY_BORDER_RADIUS_LEFT,
    EDUCATION_PADDING_TOP,
    EDUCATION_PADDING_RIGHT,
    EDUCATION_PADDING_BOTTOM,
    EDUCATION_PADDING_LEFT,
    EDUCATION_BORDER_RADIUS_TOP,
    EDUCATION_BORDER_RADIUS_RIGHT,
    EDUCATION_BORDER_RADIUS_BOTTOM,
    EDUCATION_BORDER_RADIUS_LEFT,
    EXPERIENCE_PADDING_TOP,
    EXPERIENCE_PADDING_RIGHT,
    EXPERIENCE_PADDING_BOTTOM,
    EXPERIENCE_PADDING_LEFT,
    EXPERIENCE_BORDER_RADIUS_TOP,
    EXPERIENCE_BORDER_RADIUS_RIGHT,
    EXPERIENCE_BORDER_RADIUS_BOTTOM,
    EXPERIENCE_BORDER_RADIUS_LEFT,
    REFERENCE_PADDING_TOP,
    REFERENCE_PADDING_RIGHT,
    REFERENCE_PADDING_BOTTOM,
    REFERENCE_PADDING_LEFT,
    REFERENCE_BORDER_RADIUS_TOP,
    REFERENCE_BORDER_RADIUS_RIGHT,
    REFERENCE_BORDER_RADIUS_BOTTOM,
    REFERENCE_BORDER_RADIUS_LEFT,
    ABOUT_SECTION_PADDING_TOP,
    ABOUT_SECTION_PADDING_RIGHT,
    ABOUT_SECTION_PADDING_BOTTOM,
    ABOUT_SECTION_PADDING_LEFT,
    CONTACT_SECTION_PADDING_TOP,
    CONTACT_SECTION_PADDING_RIGHT,
    CONTACT_SECTION_PADDING_BOTTOM,
    CONTACT_SECTION_PADDING_LEFT,
    SKILL_SECTION_PADDING_TOP,
    SKILL_SECTION_PADDING_RIGHT,
    SKILL_SECTION_PADDING_BOTTOM,
    SKILL_SECTION_PADDING_LEFT,
    SKILL_BAR_GAP,
    LANGUAGE_SECTION_PADDING_TOP,
    LANGUAGE_SECTION_PADDING_RIGHT,
    LANGUAGE_SECTION_PADDING_BOTTOM,
    LANGUAGE_SECTION_PADDING_LEFT,
    LANGUAGE_BAR_GAP,
    HOBBY_SECTION_PADDING_TOP,
    HOBBY_SECTION_PADDING_RIGHT,
    HOBBY_SECTION_PADDING_BOTTOM,
    HOBBY_SECTION_PADDING_LEFT,
    EDUCATION_SECTION_PADDING_TOP,
    EDUCATION_SECTION_PADDING_RIGHT,
    EDUCATION_SECTION_PADDING_BOTTOM,
    EDUCATION_SECTION_PADDING_LEFT,
    EXPERIENCE_SECTION_PADDING_TOP,
    EXPERIENCE_SECTION_PADDING_RIGHT,
    EXPERIENCE_SECTION_PADDING_BOTTOM,
    EXPERIENCE_SECTION_PADDING_LEFT,
    REFERENCE_SECTION_PADDING_TOP,
    REFERENCE_SECTION_PADDING_RIGHT,
    REFERENCE_SECTION_PADDING_BOTTOM,
    REFERENCE_SECTION_PADDING_LEFT,
    HEADER_PADDING_TOP,
    HEADER_PADDING_RIGHT,
    HEADER_PADDING_BOTTOM,
    HEADER_PADDING_LEFT,
    FOOTER_PADDING_TOP,
    FOOTER_PADDING_RIGHT,
    FOOTER_PADDING_BOTTOM,
    FOOTER_PADDING_LEFT,
  } = Constants;
  const aboutPaddingControl = [
    ABOUT_PADDING_TOP,
    ABOUT_PADDING_RIGHT,
    ABOUT_PADDING_BOTTOM,
    ABOUT_PADDING_LEFT,
  ];
  const aboutBorderRadiusControl = [
    ABOUT_BORDER_RADIUS_TOP,
    ABOUT_BORDER_RADIUS_RIGHT,
    ABOUT_BORDER_RADIUS_BOTTOM,
    ABOUT_BORDER_RADIUS_LEFT,
  ];
  const contactPaddingControl = [
    CONTACT_PADDING_TOP,
    CONTACT_PADDING_RIGHT,
    CONTACT_PADDING_BOTTOM,
    CONTACT_PADDING_LEFT,
  ];
  const contactBorderRadiusControl = [
    CONTACT_BORDER_RADIUS_TOP,
    CONTACT_BORDER_RADIUS_RIGHT,
    CONTACT_BORDER_RADIUS_BOTTOM,
    CONTACT_BORDER_RADIUS_LEFT,
  ];
  const skillPaddingControl = [
    SKILL_PADDING_TOP,
    SKILL_PADDING_RIGHT,
    SKILL_PADDING_BOTTOM,
    SKILL_PADDING_LEFT,
  ];
  const skillBorderRadiusControl = [
    SKILL_BORDER_RADIUS_TOP,
    SKILL_BORDER_RADIUS_RIGHT,
    SKILL_BORDER_RADIUS_BOTTOM,
    SKILL_BORDER_RADIUS_LEFT,
  ];
  const languagePaddingControl = [
    LANGUAGE_PADDING_TOP,
    LANGUAGE_PADDING_RIGHT,
    LANGUAGE_PADDING_BOTTOM,
    LANGUAGE_PADDING_LEFT,
  ];
  const languageBorderRadiusControl = [
    LANGUAGE_BORDER_RADIUS_TOP,
    LANGUAGE_BORDER_RADIUS_RIGHT,
    LANGUAGE_BORDER_RADIUS_BOTTOM,
    LANGUAGE_BORDER_RADIUS_LEFT,
  ];
  const hobbyPaddingControl = [
    HOBBY_PADDING_TOP,
    HOBBY_PADDING_RIGHT,
    HOBBY_PADDING_BOTTOM,
    HOBBY_PADDING_LEFT,
  ];
  const hobbyBorderRadiusControl = [
    HOBBY_BORDER_RADIUS_TOP,
    HOBBY_BORDER_RADIUS_RIGHT,
    HOBBY_BORDER_RADIUS_BOTTOM,
    HOBBY_BORDER_RADIUS_LEFT,
  ];
  const educationPaddingControl = [
    EDUCATION_PADDING_TOP,
    EDUCATION_PADDING_RIGHT,
    EDUCATION_PADDING_BOTTOM,
    EDUCATION_PADDING_LEFT,
  ];
  const educationBorderRadiusControl = [
    EDUCATION_BORDER_RADIUS_TOP,
    EDUCATION_BORDER_RADIUS_RIGHT,
    EDUCATION_BORDER_RADIUS_BOTTOM,
    EDUCATION_BORDER_RADIUS_LEFT,
  ];
  const experiencePaddingControl = [
    EXPERIENCE_PADDING_TOP,
    EXPERIENCE_PADDING_RIGHT,
    EXPERIENCE_PADDING_BOTTOM,
    EXPERIENCE_PADDING_LEFT,
  ];
  const experienceBorderRadiusControl = [
    EXPERIENCE_BORDER_RADIUS_TOP,
    EXPERIENCE_BORDER_RADIUS_RIGHT,
    EXPERIENCE_BORDER_RADIUS_BOTTOM,
    EXPERIENCE_BORDER_RADIUS_LEFT,
  ];
  const referencePaddingControl = [
    REFERENCE_PADDING_TOP,
    REFERENCE_PADDING_RIGHT,
    REFERENCE_PADDING_BOTTOM,
    REFERENCE_PADDING_LEFT,
  ];
  const referenceBorderRadiusControl = [
    REFERENCE_BORDER_RADIUS_TOP,
    REFERENCE_BORDER_RADIUS_RIGHT,
    REFERENCE_BORDER_RADIUS_BOTTOM,
    REFERENCE_BORDER_RADIUS_LEFT,
  ];
  const aboutSectionPadding = [
    ABOUT_SECTION_PADDING_TOP,
    ABOUT_SECTION_PADDING_RIGHT,
    ABOUT_SECTION_PADDING_BOTTOM,
    ABOUT_SECTION_PADDING_LEFT,
  ];
  const contactSectionPadding = [
    CONTACT_SECTION_PADDING_TOP,
    CONTACT_SECTION_PADDING_RIGHT,
    CONTACT_SECTION_PADDING_BOTTOM,
    CONTACT_SECTION_PADDING_LEFT,
  ];
  const skillSectionPadding = [
    SKILL_SECTION_PADDING_TOP,
    SKILL_SECTION_PADDING_RIGHT,
    SKILL_SECTION_PADDING_BOTTOM,
    SKILL_SECTION_PADDING_LEFT,
  ];
  const languageSectionPadding = [
    LANGUAGE_SECTION_PADDING_TOP,
    LANGUAGE_SECTION_PADDING_RIGHT,
    LANGUAGE_SECTION_PADDING_BOTTOM,
    LANGUAGE_SECTION_PADDING_LEFT,
  ];
  const hobbySectionPadding = [
    HOBBY_SECTION_PADDING_TOP,
    HOBBY_SECTION_PADDING_RIGHT,
    HOBBY_SECTION_PADDING_BOTTOM,
    HOBBY_SECTION_PADDING_LEFT,
  ];
  const educationSectionPadding = [
    EDUCATION_SECTION_PADDING_TOP,
    EDUCATION_SECTION_PADDING_RIGHT,
    EDUCATION_SECTION_PADDING_BOTTOM,
    EDUCATION_SECTION_PADDING_LEFT,
  ];
  const experienceSectionPadding = [
    EXPERIENCE_SECTION_PADDING_TOP,
    EXPERIENCE_SECTION_PADDING_RIGHT,
    EXPERIENCE_SECTION_PADDING_BOTTOM,
    EXPERIENCE_SECTION_PADDING_LEFT,
  ];
  const referenceSectionPadding = [
    REFERENCE_SECTION_PADDING_TOP,
    REFERENCE_SECTION_PADDING_RIGHT,
    REFERENCE_SECTION_PADDING_BOTTOM,
    REFERENCE_SECTION_PADDING_LEFT,
  ];
  const headerPaddingControl = [
    HEADER_PADDING_TOP,
    HEADER_PADDING_RIGHT,
    HEADER_PADDING_BOTTOM,
    HEADER_PADDING_LEFT,
  ];
  const footerPaddingControl = [
    FOOTER_PADDING_TOP,
    FOOTER_PADDING_RIGHT,
    FOOTER_PADDING_BOTTOM,
    FOOTER_PADDING_LEFT,
  ];
  const getSectionItems = () => {
    switch (style) {
      case 'style26':
        return sectionItems26 || [];
      case 'style27':
        return sectionItems27 || [];
      case 'style28':
        return sectionItems28 || [];
      case 'style21':
        return sectionItems21 || [];
      case 'style22':
        return sectionItems22 || [];
      case 'style1':
        return sectionItems1 || [];
      case 'style2':
        return sectionItems2 || [];
      case 'style3':
        return sectionItems3 || [];
      case 'style4':
        return sectionItems4 || [];
      case 'style5':
        return sectionItems5 || [];
      case 'style6':
        return sectionItems6 || [];
      case 'style7':
        return sectionItems7 || [];
      case 'style8':
        return sectionItems8 || [];
      case 'style9':
        return sectionItems9 || [];
      case 'style10':
        return sectionItems10 || [];
      case 'style11':
        return sectionItems11 || [];
      case 'style12':
        return sectionItems12 || [];
      case 'style13':
        return sectionItems13 || [];
      case 'style14':
        return sectionItems14 || [];
      case 'style15':
        return sectionItems15 || [];
      case 'style16':
        return sectionItems16 || [];
      case 'style17':
        return sectionItems17 || [];
      case 'style18':
        return sectionItems18 || [];
      case 'style19':
        return sectionItems19 || [];
      case 'style20':
        return sectionItems20 || [];
      case 'style23':
        return sectionItems23 || [];
      case 'style24':
        return sectionItems24 || [];
      case 'style25':
        return sectionItems25 || [];
      default:
        return sectionItems || [];
    }
  };

  const setSectionItems = (newItems) => {
    switch (style) {
      case 'style26':
        setAttributes({ sectionItems26: newItems });
        break;
      case 'style27':
        setAttributes({ sectionItems27: newItems });
        break;
      case 'style28':
        setAttributes({ sectionItems28: newItems });
        break;
      case 'style21':
        setAttributes({ sectionItems21: newItems });
        break;
      case 'style22':
        setAttributes({ sectionItems22: newItems });
        break;
      case 'style2':
        setAttributes({ sectionItems2: newItems });
        break;
      case 'style10':
        setAttributes({ sectionItems10: newItems });
        break;
      case 'style11':
        setAttributes({ sectionItems11: newItems });
        break;
      case 'style12':
        setAttributes({ sectionItems12: newItems });
        break;
      case 'style13':
        setAttributes({ sectionItems13: newItems });
        break;
      case 'style14':
        setAttributes({ sectionItems14: newItems });
        break;
      case 'style15':
        setAttributes({ sectionItems15: newItems });
        break;
      case 'style16':
        setAttributes({ sectionItems16: newItems });
        break;
      case 'style17':
        setAttributes({ sectionItems17: newItems });
        break;
      case 'style18':
        setAttributes({ sectionItems18: newItems });
        break;
      case 'style19':
        setAttributes({ sectionItems19: newItems });
        break;
      case 'style20':
        setAttributes({ sectionItems20: newItems });
        break;
      case 'style23':
        setAttributes({ sectionItems23: newItems });
        break;
      case 'style24':
        setAttributes({ sectionItems24: newItems });
        break;
      case 'style25':
        setAttributes({ sectionItems25: newItems });
        break;
      case 'style4':
        setAttributes({ sectionItems4: newItems });
        break;
      case 'style3':
        setAttributes({ sectionItems3: newItems });
        break;
      case 'style5':
        setAttributes({ sectionItems5: newItems });
        break;
      case 'style6':
        setAttributes({ sectionItems6: newItems });
        break;
      case 'style7':
        setAttributes({ sectionItems7: newItems });
        break;
      case 'style8':
        setAttributes({ sectionItems8: newItems });
        break;
      case 'style9':
        setAttributes({ sectionItems9: newItems });
        break;
      case 'style1':
        setAttributes({ sectionItems1: newItems });
        break;
      default:
        setAttributes({ sectionItems: newItems });
        break;
    }
  };
  const {
    CustomPublishPreviewButtons,
    ImageSelector,
    ThemeColorControl,
    ColorControl,
    MyTypographyControl,
    TabPanelControl,
    ResRangleControl,
    ResDimensionControl,
    AdminImageSelector
  } = Controls;

  const handleYearMonChange = (date, sectionIndex, itemIndex, fieldName) => {
    const currentSectionItems = getSectionItems();
    const newSectionItems = [...currentSectionItems];

    if (date && date instanceof Date && !isNaN(date)) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const formattedDate = `${year}-${month}`;
      newSectionItems[sectionIndex].items[itemIndex][fieldName] = formattedDate;
    } else {
      newSectionItems[sectionIndex].items[itemIndex][fieldName] = null;
    }

    setSectionItems(newSectionItems);
  };

  const handleAddItem = (sectionIndex) => {
    const newSectionItems = [...getSectionItems()];
    const section = newSectionItems[sectionIndex];
    const newItem =
      section.type === 'skills'
        ? { name: '', percentage: 0 }
        : section.type === 'hobbies'
          ? { name: '', icon: '' }
          : {};
    newSectionItems[sectionIndex] = {
      ...section,
      items: [...(section.items || []), newItem],
    };
    setSectionItems(newSectionItems);
  };

  const handleRemoveItem = (sectionIndex, itemIndex) => {
    const newSectionItems = [...getSectionItems()];
    const section = newSectionItems[sectionIndex];
    const newItems = [...section.items];
    newItems.splice(itemIndex, 1);
    newSectionItems[sectionIndex] = {
      ...section,
      items: newItems,
    };
    setSectionItems(newSectionItems);
  };

  const handleDuplicateItem = (sectionIndex, itemIndex) => {
    const newSectionItems = [...getSectionItems()];
    const section = newSectionItems[sectionIndex];
    const itemToDuplicate = JSON.parse(
      JSON.stringify(section.items[itemIndex])
    );
    const newItems = [...section.items];
    newItems.splice(itemIndex + 1, 0, itemToDuplicate);
    newSectionItems[sectionIndex] = {
      ...section,
      items: newItems,
    };
    setSectionItems(newSectionItems);
  };

  const handleChangeItemField = (value, sectionIndex, itemIndex, field) => {
    const sectionItems = getSectionItems();
    const updatedSections = sectionItems.map((section, secIdx) => {
      if (secIdx === sectionIndex) {
        return {
          ...section,
          items: section.items.map((item, idx) =>
            idx === itemIndex ? { ...item, [field]: value } : item
          ),
        };
      }
      return section;
    });
    setSectionItems(updatedSections);
  };

  const handleRemoveSection = (sectionIndex) => {
    const currentSections = [...getSectionItems()];
    const sectionToRemove = currentSections[sectionIndex];
    const currentDeletedSectionsData = deletedSectionsData || {};
    const updatedDeletedSectionsData = {
      ...currentDeletedSectionsData,
      [sectionToRemove.type]: {
        sectionData: sectionToRemove,
        position: sectionIndex
      }
    }
    setAttributes({ deletedSectionsData: updatedDeletedSectionsData });
    currentSections.splice(sectionIndex, 1);
    setSectionItems(currentSections);
  };

  const onSectionDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination, type } = result;
    const sectionItems = getSectionItems();

    if (type === 'section') {
      const updatedSections = Array.from(sectionItems);
      const [movedSection] = updatedSections.splice(source.index, 1);
      updatedSections.splice(destination.index, 0, movedSection);
      setSectionItems(updatedSections);
    } else if (type === 'item') {
      const sectionIndex = parseInt(source.droppableId.replace('items-', ''));
      const updatedSections = [...sectionItems];
      const updatedItems = Array.from(updatedSections[sectionIndex].items);
      const [movedItem] = updatedItems.splice(source.index, 1);
      updatedItems.splice(destination.index, 0, movedItem);
      updatedSections[sectionIndex].items = updatedItems;
      setSectionItems(updatedSections);
    }
  };

  const handleDateChange = (date, sectionIndex) => {
    if (!date) {
      handleChangeSectionField(null, sectionIndex, 'dateOfBirth');
      return;
    }
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    handleChangeSectionField(formattedDate, sectionIndex, 'dateOfBirth');
  };


  const handleYearChange = (date, sectionIndex, itemIndex, fieldName) => {
    const currentSectionItems = [...getSectionItems()];
    currentSectionItems[sectionIndex].items[itemIndex][fieldName] = date
      ? date.toISOString()
      : null;
    setSectionItems(currentSectionItems);
  };

  const handleChangeSectionField = (value, index, field) => {
    const updatedSections = [...getSectionItems()];
    updatedSections[index] = {
      ...updatedSections[index],
      [field]: value,
    };
    setSectionItems(updatedSections);
  };


  const capitalizeTitle = (title, index, titles) => {
    if (typeof title === 'string' && title.trim().length > 0) {
      return title.charAt(0).toUpperCase() + title.slice(1);
    }
    return titles?.[index] || `Section ${index + 1}`;
  };

  // Hooks Declaration
  const showPresetTemplate = applyFilters(
    'bwdcv-preset-template-visibility',
    true
  );
  const showGlobalStyle = applyFilters(
    'bwdcv-global-style-visibility',
    false
  );
  const dashPreviewBannerInspect = applyFilters(
    'bwdcv-dash-preview-banner-inspect',
    false
  );
  const footerVisibility = applyFilters('bwdcv-footer-visibility', true);
  const truncateTitle = (text, maxLength = 20) => {
    if (!text) return 'New Item';
    return text.length > maxLength
      ? text.substring(0, maxLength) + '...'
      : text;
  };
  const getCurrentSectionCount = (style) => {
    const sectionCountMap = {
      'style1': sectionCountOne,
      'style2': sectionCountTwo,
      'style3': sectionCountThree,
      'style4': sectionCountFour,
      'style5': sectionCountFive,
      'style6': sectionCountSix,
      'style7': sectionCountSeven,
      'style8': sectionCountEight,
      'style9': sectionCountNine,
      'style10': sectionCountTen,
      'style11': sectionCountEleven,
      'style12': sectionCountTwelve,
      'style13': sectionCountThirteen,
      'style14': sectionCountFourteen,
      'style15': sectionCountFifteen,
      'style16': sectionCountSixteen,
      'style17': sectionCountSeventeen,
      'style18': sectionCountEighteen,
      'style19': sectionCountNineteen,
      'style20': sectionCountTwenty,
      'style21': sectionCountTwentyOne,
      'style22': sectionCountTwentyTwo,
      'style23': sectionCountTwentyThree,
      'style24': sectionCountTwentyFour,
      'style25': sectionCountTwentyFive,
    };

    return sectionCountMap[style] || sectionCountOne;
  };

  // Create a helper function to update the current template's section count
  const updateCurrentSectionCount = (style, value) => {
    const attributeMap = {
      'style1': 'sectionCountOne',
      'style2': 'sectionCountTwo',
      'style3': 'sectionCountThree',
      'style4': 'sectionCountFour',
      'style5': 'sectionCountFive',
      'style6': 'sectionCountSix',
      'style7': 'sectionCountSeven',
      'style8': 'sectionCountEight',
      'style9': 'sectionCountNine',
      'style10': 'sectionCountTen',
      'style11': 'sectionCountEleven',
      'style12': 'sectionCountTwelve',
      'style13': 'sectionCountThirteen',
      'style14': 'sectionCountFourteen',
      'style15': 'sectionCountFifteen',
      'style16': 'sectionCountSixteen',
      'style17': 'sectionCountSeventeen',
      'style18': 'sectionCountEighteen',
      'style19': 'sectionCountNineteen',
      'style20': 'sectionCountTwenty',
      'style21': 'sectionCountTwentyOne',
      'style22': 'sectionCountTwentyTwo',
      'style23': 'sectionCountTwentyThree',
      'style24': 'sectionCountTwentyFour',
      'style25': 'sectionCountTwentyFive',
    };
    const attributeName = attributeMap[style] || 'sectionCountOne';
    setAttributes({ [attributeName]: parseInt(value, 10) });
  };
  const currentSectionItems = getSectionItems();

  const allImagesSequential = useMemo(() => {
    return (userData?.allImages || []).flatMap((postItem, postIndex) =>
      postItem.images.map((img, index) => {
        const allPreviousImages = userData?.allImages
          .slice(0, postIndex)
          .reduce((total, post) => total + post.images.length, 0);
        const labelNumber = 29 + allPreviousImages + index;

        const option = {
          value: String(postItem.post_id),
          templateId: postItem.post_id,
          label: `Style ${labelNumber}`,
          imageUrl: img.imageUrl,
          _debug: {
            displayStyle: labelNumber,
            actualTemplateId: postItem.post_id,
          },
        };
        return option;
      })
    );
  }, [userData]);

  const allImages = allImagesSequential;
  const mergedOptions = useMemo(() => {
    return [...SelectStyle, ...allImages];
  }, [SelectStyle, allImages]);

  const allAdminImages = (userData?.allImages || []).flatMap((postItem, postIndex) =>
    postItem.images.map((img, index) => {
      const allPreviousImages = userData?.allImages
        .slice(0, postIndex)
        .reduce((total, post) => total + post.images.length, 0);
      const labelNumber = 29 + allPreviousImages + index;

      return {
        value: `${postItem.post_id}`,
        templateId: postItem.post_id,
        label: `Style ${labelNumber}`,
        imageUrl: img.imageUrl,
      };
    })
  );
  const mergedAdminOptions = [...AdminSelectedStyle, ...allAdminImages];

  return (
    <InspectorControls>
      {!userData.isAdmin && dashPreviewBannerInspect && (
        <CustomPublishPreviewButtons />
      )}
      <Fragment>
        <TabPanelControl
          tabs={[
            {
              name: 'gutnm_normal',
              className: 'gutnm-tab gutnm-general',
              icon: 'edit',
              title: 'Content',
              components: (
                <Fragment>
                  <div className="first-two-container-wrapper">
                    {/* Start Preset Template Tab ---------------*/}
                    {showPresetTemplate && (
                      <PanelBody
                        title={__('Preset Template', 'cv-builder')}
                        className="bwdcvs-tab-heading"
                        initialOpen={false}
                      >
                        {
                          userData.isAdmin && (
                            <AdminImageSelector
                              options={mergedAdminOptions}
                              value={style}
                              onChange={(selectedStyle) =>
                                setAttributes({ style: selectedStyle })
                              }
                            />
                          )
                        }
                        {
                          !userData.isAdmin && (
                            <ImageSelector
                              options={mergedOptions}
                              value={style}
                              onChange={(selectedStyle) =>
                                setAttributes({ style: selectedStyle })
                              }
                            />
                          )
                        }

                      </PanelBody>
                    )}
                    {
                      !userData.isAdmin && style !== 'style26' && style !== 'style27' && style !== 'style28' && (
                        <PanelBody
                          title={__(
                            'Global Style',
                            'cv-builder'
                          )}
                          className='bwdcvs-tab-heading'
                          initialOpen={false}
                        >
                          <ColorControl
                            label={__(
                              'Theme Color',
                              'cv-builder'
                            )}
                            color={themeColor}
                            colorName="themeColor"
                            onChange={bwdcv_data?.licenseStatus === 'activate' ? setAttributes : ''}
                          />
                          <MyTypographyControl
                            label={__(
                              'Typography',
                              'cv-builder'
                            )}
                            typography={
                              typography
                            }
                            onChange={(value) => {
                              if (bwdcv_data?.licenseStatus === 'activate') {
                                setAttributes({
                                  typography:
                                    value,
                                });
                              }
                            }}
                            attribute={attributes}
                            setAttributes={setAttributes}
                          />
                          <TextControl
                            label={__(
                              'Section Count',
                              'cv-builder'
                            )}
                            type="number"
                            value={getCurrentSectionCount(style)}
                            onChange={(value) => bwdcv_data?.licenseStatus === 'activate' ? updateCurrentSectionCount(style, value) : ''}
                          />
                        </PanelBody>
                      )
                    }

                    {/* Start Profile Tab ---------------*/}
                    <PanelBody
                      title={__('Profile', 'cv-builder')}
                      className="bwdcvs-tab-heading"
                      initialOpen={true}
                      icon="admin-users"
                    >
                      <ProfileControl
                        attributes={attributes}
                        setAttributes={setAttributes}
                      />
                    </PanelBody>
                  </div>
                  <div className="bwdcv-repeater-content-wrapper">
                    {currentSectionItems.length > 0 && (
                      <DragDropContext onDragEnd={onSectionDragEnd}>
                        <Droppable droppableId="sections" type="section">
                          {(provided) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {currentSectionItems.map((section, index) => (
                                <Draggable
                                  key={section.id}
                                  draggableId={`section-${section.id}`}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      ref={
                                        provided.innerRef
                                      }
                                      {...provided.draggableProps}
                                      className="draggable-section"
                                      id={`section${section.id}`}
                                    >
                                      <div
                                        {...provided.dragHandleProps}
                                        className="bwdtm-drag-handle"
                                      >
                                        ☰
                                      </div>
                                      <PanelBody
                                        title={capitalizeTitle(
                                          decodeEntities(section?.title),
                                          index
                                        )}
                                        initialOpen={
                                          false
                                        }
                                        className="bwdcvs-tab-heading"
                                      >

                                        <TextControl
                                          label={__('Section Title', 'cv-builder')}
                                          value={decodeEntities(section.title || '')}
                                          onChange={(value) =>
                                            handleChangeSectionField(
                                              value,
                                              index,
                                              'title'
                                            )
                                          }
                                        />
                                        <hr />

                                        {/* Start About Tab ---------------*/}
                                        {section.type === 'about' && (
                                          <>
                                            <AboutControl
                                              section={section}
                                              index={index}
                                              handleChangeSectionField={handleChangeSectionField}
                                              handleDateChange={handleDateChange}
                                              aboutDescColor={aboutDescColor}
                                              setAttributes={setAttributes}
                                              attributes={attributes}
                                            />
                                          </>
                                        )}
                                        {/* Start Contact Tab ---------------*/}
                                        {section.type === 'contact' && (
                                          <>
                                            <ContactControl
                                              section={section}
                                              index={index}
                                              getSectionItems={getSectionItems}
                                              setSectionItems={setSectionItems}
                                              handleChangeSectionField={handleChangeSectionField}
                                            />

                                          </>
                                        )}
                                        {/* Start Section Inside Repeater  ---------------*/}
                                        {section.items && (
                                          <Droppable
                                            droppableId={`items-${index}`}
                                            type="item"
                                          >
                                            {(
                                              provided
                                            ) => (
                                              <div
                                                {...provided.droppableProps}
                                                ref={
                                                  provided.innerRef
                                                }
                                                className="bwdcv-repeater-cluster"
                                              >
                                                {Array.isArray(
                                                  section.items
                                                ) &&
                                                  section.items.map(
                                                    (
                                                      item,
                                                      itemIndex
                                                    ) => (
                                                      <Draggable
                                                        key={`item-${itemIndex}`}
                                                        draggableId={`item-${itemIndex}`}
                                                        index={
                                                          itemIndex
                                                        }
                                                      >
                                                        {(
                                                          provided
                                                        ) => (
                                                          <div
                                                            ref={
                                                              provided.innerRef
                                                            }
                                                            {...provided.draggableProps}
                                                            className="inner-repeater-wrap"
                                                          >
                                                            <div className="bwdcv-repeater-wrapper">
                                                              <PanelBody
                                                                key={
                                                                  itemIndex
                                                                }
                                                                title={truncateTitle(item.name, 20)}
                                                                initialOpen={
                                                                  false
                                                                }
                                                                className="bwdcvs-tab-heading"
                                                              >

                                                                <div className="item-fields">
                                                                  {/* Start Skills Tab ---------------*/}
                                                                  {section.type === 'skills' && (
                                                                    <>
                                                                      <SkillsControl
                                                                        section={section}
                                                                        index={index}
                                                                        item={item}
                                                                        itemIndex={itemIndex}
                                                                        handleChangeItemField={
                                                                          handleChangeItemField
                                                                        }
                                                                      />
                                                                    </>
                                                                  )}
                                                                  {/* Start Languages Tab ---------------*/}
                                                                  {section.type === 'languages' && (
                                                                    <>
                                                                      <LanguagesControl
                                                                        section={section}
                                                                        index={index}
                                                                        item={item}
                                                                        itemIndex={itemIndex}
                                                                        handleChangeItemField={handleChangeItemField}
                                                                      />
                                                                    </>
                                                                  )}
                                                                  {/* Start Hobbies Tab ---------------*/}
                                                                  {section.type === 'hobbies' && (
                                                                    <>
                                                                      <HobbiesControl
                                                                        section={section}
                                                                        index={index}
                                                                        item={item}
                                                                        itemIndex={itemIndex}
                                                                        handleChangeItemField={handleChangeItemField}
                                                                      />
                                                                    </>
                                                                  )}
                                                                  {/* Start Education Tab ---------------*/}
                                                                  {section.type === 'education' && (
                                                                    <>
                                                                      <EducationControl
                                                                        index={index}
                                                                        item={item}
                                                                        itemIndex={itemIndex}
                                                                        handleChangeItemField={handleChangeItemField}
                                                                        handleYearChange={handleYearChange}
                                                                        handleYearMonChange={handleYearMonChange}
                                                                      />
                                                                    </>
                                                                  )}
                                                                  {/* Start Experience Tab ---------------*/}
                                                                  {section.type === 'experience' && (
                                                                    <>
                                                                      <ExperienceControl
                                                                        index={index}
                                                                        item={item}
                                                                        itemIndex={itemIndex}
                                                                        sectionItems={getSectionItems()}
                                                                        setAttributes={setAttributes}
                                                                        handleChangeItemField={handleChangeItemField}
                                                                        handleYearMonChange={handleYearMonChange}
                                                                      />

                                                                    </>
                                                                  )}
                                                                  {/* Start Reference Tab ---------------*/}
                                                                  {section.type === 'reference' && (
                                                                    <>
                                                                      <ReferenceControl
                                                                        index={index}
                                                                        item={item}
                                                                        itemIndex={itemIndex}
                                                                        handleChangeItemField={handleChangeItemField}
                                                                      />
                                                                    </>
                                                                  )}
                                                                  {/* Start Award Tab ---------------*/}
                                                                  {section.type === 'awards' && (
                                                                    <>
                                                                      <AwardControl
                                                                        section={section}
                                                                        index={index}
                                                                        item={item}
                                                                        itemIndex={itemIndex}
                                                                        handleChangeItemField={
                                                                          handleChangeItemField
                                                                        }
                                                                      />
                                                                    </>
                                                                  )}
                                                                  {/* Start Tools Tab ---------------*/}
                                                                  {section.type === 'tools' && (
                                                                    <>
                                                                      <ToolsControl
                                                                        section={section}
                                                                        index={index}
                                                                        item={item}
                                                                        itemIndex={itemIndex}
                                                                        handleChangeItemField={
                                                                          handleChangeItemField
                                                                        }
                                                                      />
                                                                    </>
                                                                  )}
                                                                </div>
                                                              </PanelBody>
                                                              {section.type !== 'about' && section.type !== 'contact' && (
                                                                <>
                                                                  <div
                                                                    {...provided.dragHandleProps}
                                                                    className="bwdtm-drag-handle"
                                                                  >
                                                                    ☰
                                                                  </div>
                                                                  <Button
                                                                    onClick={() =>
                                                                      handleDuplicateItem(
                                                                        index,
                                                                        itemIndex
                                                                      )
                                                                    }
                                                                    className="duplicate-item-button"
                                                                    label={__(
                                                                      'Duplicate Item',
                                                                      'cv-builder'
                                                                    )}
                                                                  >
                                                                    {' '}
                                                                    <svg
                                                                      width="20"
                                                                      height="20"
                                                                      viewBox="0 0 448 512"
                                                                    >
                                                                      <path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" />
                                                                    </svg>
                                                                  </Button>

                                                                  <Button
                                                                    isDestructive
                                                                    onClick={() =>
                                                                      handleRemoveItem(
                                                                        index,
                                                                        itemIndex
                                                                      )
                                                                    }
                                                                    className="delete-item-button"
                                                                  >
                                                                    <span className="dashicons dashicons-trash"></span>
                                                                  </Button>
                                                                </>
                                                              )}
                                                            </div>
                                                          </div>
                                                        )}
                                                      </Draggable>
                                                    )
                                                  )}
                                                {
                                                  provided.placeholder
                                                }
                                                {section.type !== 'about' && section.type !== 'contact' && (
                                                  <div className="bwdcv-add-btn-wrap">
                                                    <button
                                                      onClick={() =>
                                                        handleAddItem(
                                                          index
                                                        )
                                                      }
                                                      className="add-item-button"
                                                    >
                                                      {__(
                                                        'Add New Item',
                                                        'cv-builder'
                                                      )}
                                                      <Elevation
                                                        active={
                                                          1
                                                        }
                                                        focus={
                                                          5
                                                        }
                                                        hover={
                                                          7
                                                        }
                                                        value={
                                                          5
                                                        }
                                                      />
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </Droppable>
                                        )}
                                      </PanelBody>
                                      <Button
                                        isDestructive
                                        onClick={() =>
                                          handleRemoveSection(
                                            index
                                          )
                                        }
                                        className="trash-icon"
                                      >
                                        <span className="dashicons dashicons-trash"></span>
                                      </Button>
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    )}
                  </div>
                  {
                    footerVisibility && (
                      <FooterControl
                        setAttributes={setAttributes}
                        footerPanel={footerPanel}
                        isFooterVisible={isFooterVisible}
                        signature={signature}
                        footerLink={footerLink}
                        footerBtnText={footerBtnText}
                        footerBtnLink={footerBtnLink}
                        signatureImageUrl={signatureImageUrl}
                      />
                    )
                  }
                  <AddSection
                    setAttributes={setAttributes}
                    getSectionItems={getSectionItems}
                    setSectionItems={setSectionItems}
                  />
                </Fragment>
              ),
            },
            {
              name: 'gutnm_hover',
              title: 'Style',
              className: 'gutnm-tab gutnm-style',
              icon: 'editor-code',
              components: (
                <Fragment>
                  <PanelBody
                    title={__(
                      'Header',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ResRangleControl
                      label={__(
                        'Profile Image Size',
                        'cv-builder'
                      )}
                      controlName={IMAGE_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={300}
                    />
                    <ResRangleControl
                      label={__(
                        'Image Border Radius',
                        'cv-builder'
                      )}
                      controlName={IMAGE_BORDER_RADIUS}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ColorControl
                      label={__(
                        'Name Color',
                        'cv-builder'
                      )}
                      color={userNameColor}
                      colorName="userNameColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Name Font Size',
                        'cv-builder'
                      )}
                      controlName={NAME_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <MyTypographyControl
                      label={__(
                        'Name Typography',
                        'cv-builder'
                      )}
                      typography={userNameTypography}
                      onChange={(value) => {
                        setAttributes({
                          userNameTypography: value,
                        });
                      }}
                      attribute={attributes}
                      setAttributes={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Designation Color',
                        'cv-builder'
                      )}
                      color={designationColor}
                      colorName="designationColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Designation Font Size',
                        'cv-builder'
                      )}
                      controlName={DESIGNATION_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <MyTypographyControl
                      label={__(
                        'Designation Typography',
                        'cv-builder'
                      )}
                      typography={designationTypography}
                      onChange={(value) => {
                        setAttributes({
                          designationTypography:
                            value,
                        });
                      }}
                      attribute={attributes}
                      setAttributes={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Icon Color',
                        'cv-builder'
                      )}
                      color={iconColor}
                      colorName="iconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Icon Background Color',
                        'cv-builder'
                      )}
                      color={iconBackgroundColor}
                      colorName="iconBackgroundColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Icon Size',
                        'cv-builder'
                      )}
                      controlName={ICON_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Icon Border Radius',
                        'cv-builder'
                      )}
                      controlName={ICON_BORDER_RADIUS}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Icon Gap',
                        'cv-builder'
                      )}
                      controlName={ICON_GAP}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Icon Round Size',
                        'cv-builder'
                      )}
                      controlName={ICON_ROUND_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ColorControl
                      label={__(
                        'Header Background Color',
                        'cv-builder'
                      )}
                      color={headerBackgroundColor}
                      colorName="headerBackgroundColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'QR Position Horizontal',
                        'cv-builder'
                      )}
                      controlName={QR_POSITION_HORIZONTAL}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'QR Position Vertical',
                        'cv-builder'
                      )}
                      controlName={QR_POSITION_VERTICAL}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResDimensionControl
                      label={__(
                        'Header Padding',
                        'cv-builder'
                      )}
                      controlName={headerPaddingControl}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'About Me',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Title Color',
                        'cv-builder'
                      )}
                      color={aboutTitleColor}
                      colorName="aboutTitleColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Title Icon Color',
                        'cv-builder'
                      )}
                      color={aboutTitleIconColor}
                      colorName="aboutTitleIconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Description Color',
                        'cv-builder'
                      )}
                      color={aboutDescriptionColor}
                      colorName="aboutDescriptionColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Date of Birth Color',
                        'cv-builder'
                      )}
                      color={aboutDateOfBirthColor}
                      colorName="aboutDateOfBirthColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Nationality Color',
                        'cv-builder'
                      )}
                      color={aboutNationalityColor}
                      colorName="aboutNationalityColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Title Background Color',
                        'cv-builder'
                      )}
                      color={aboutTitleBgColor}
                      colorName="aboutTitleBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Title Font Size',
                        'cv-builder'
                      )}
                      controlName={ABOUT_TITLE_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Title Icon Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        ABOUT_TITLE_ICON_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <MyTypographyControl
                      label={__(
                        'About Title Typography',
                        'cv-builder'
                      )}
                      typography={aboutTitleTypography}
                      onChange={(value) => {
                        setAttributes({
                          aboutTitleTypography: value,
                        });
                      }}
                      attribute={attributes}
                      setAttributes={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Description Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        ABOUT_DESCRIPTION_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <MyTypographyControl
                      label={__(
                        'Description Typography',
                        'cv-builder'
                      )}
                      typography={
                        aboutDescriptionTypography
                      }
                      onChange={(value) => {
                        setAttributes({
                          aboutDescriptionTypography:
                            value,
                        });
                      }}
                      attribute={attributes}
                      setAttributes={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Date Of Birth Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        DATE_OF_BIRTH_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Nationality Font Size',
                        'cv-builder'
                      )}
                      controlName={NATIONALITY_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResDimensionControl
                      label={__(
                        'About Title Padding',
                        'cv-builder'
                      )}
                      controlName={aboutPaddingControl}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'About Title Border Radius',
                        'cv-builder'
                      )}
                      controlName={
                        aboutBorderRadiusControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'About Section Padding',
                        'cv-builder'
                      )}
                      controlName={aboutSectionPadding}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Contact',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Title Color',
                        'cv-builder'
                      )}
                      color={contactTitleColor}
                      colorName="contactTitleColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Title Icon Color',
                        'cv-builder'
                      )}
                      color={contactTitleIconColor}
                      colorName="contactTitleIconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Title Background Color',
                        'cv-builder'
                      )}
                      color={contactTitleBgColor}
                      colorName="contactTitleBgColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Address Color',
                        'cv-builder'
                      )}
                      color={addressColor}
                      colorName="addressColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Contact Font Size',
                        'cv-builder'
                      )}
                      controlName={CONTACT_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResDimensionControl
                      label={__(
                        'Contact Title Padding',
                        'cv-builder'
                      )}
                      controlName={contactPaddingControl}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Contact Title Border Radius',
                        'cv-builder'
                      )}
                      controlName={
                        contactBorderRadiusControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Contact Section Padding',
                        'cv-builder'
                      )}
                      controlName={contactSectionPadding}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Skills',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Skill Title Color',
                        'cv-builder'
                      )}
                      color={skillTitleColor}
                      colorName="skillTitleColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Skill Title Icon Color',
                        'cv-builder'
                      )}
                      color={skillTitleIconColor}
                      colorName="skillTitleIconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Skill Title Background Color',
                        'cv-builder'
                      )}
                      color={skillTitleBgColor}
                      colorName="skillTitleBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Skill Title Font Size',
                        'cv-builder'
                      )}
                      controlName={SKILL_TITLE_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Skill Title Icon Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        SKILL_TITLE_ICON_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ColorControl
                      label={__(
                        'Skill Name Color',
                        'cv-builder'
                      )}
                      color={skillNameColor}
                      colorName="skillNameColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Skill Percentage Color',
                        'cv-builder'
                      )}
                      color={skillPercentageColor}
                      colorName="skillPercentageColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Skill Top Background Color',
                        'cv-builder'
                      )}
                      color={skillTopBgColor}
                      colorName="skillTopBgColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Skill Bottom Background Color',
                        'cv-builder'
                      )}
                      color={skillBottomBgColor}
                      colorName="skillBottomBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Skill Name Font Size',
                        'cv-builder'
                      )}
                      controlName={SKILL_NAME_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Skill Percentage Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        SKILL_PERCENTAGE_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Skill Bar Gap',
                        'cv-builder'
                      )}
                      controlName={SKILL_BAR_GAP}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Padding',
                        'cv-builder'
                      )}
                      controlName={skillPaddingControl}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Border Radius',
                        'cv-builder'
                      )}
                      controlName={
                        skillBorderRadiusControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Section Padding',
                        'cv-builder'
                      )}
                      controlName={skillSectionPadding}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Languages',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Language Title Color',
                        'cv-builder'
                      )}
                      color={languageTitleColor}
                      colorName="languageTitleColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Language Title Icon Color',
                        'cv-builder'
                      )}
                      color={languageTitleIconColor}
                      colorName="languageTitleIconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Language Title Background Color',
                        'cv-builder'
                      )}
                      color={languageTitleBgColor}
                      colorName="languageTitleBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Language Title Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        LANGUAGE_TITLE_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Language Title Icon Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        LANGUAGE_TITLE_ICON_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ColorControl
                      label={__(
                        'Language Name Color',
                        'cv-builder'
                      )}
                      color={languageNameColor}
                      colorName="languageNameColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Language Percentage Color',
                        'cv-builder'
                      )}
                      color={languagePercentageColor}
                      colorName="languagePercentageColor"
                      onChange={setAttributes}
                    />

                    <ColorControl
                      label={__(
                        'Language Top Background Color',
                        'cv-builder'
                      )}
                      color={languageTopBgColor}
                      colorName="languageTopBgColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Language Bottom Background Color',
                        'cv-builder'
                      )}
                      color={languageBottomBgColor}
                      colorName="languageBottomBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Language Name Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        LANGUAGE_NAME_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Language Percentage Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        LANGUAGE_PERCENTAGE_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Language Bar Gap',
                        'cv-builder'
                      )}
                      controlName={LANGUAGE_BAR_GAP}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResDimensionControl
                      label={__(
                        'Padding',
                        'cv-builder'
                      )}
                      controlName={languagePaddingControl}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Border Radius',
                        'cv-builder'
                      )}
                      controlName={
                        languageBorderRadiusControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Language Section Padding',
                        'cv-builder'
                      )}
                      controlName={languageSectionPadding}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Hobbies',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Hobby Title Color',
                        'cv-builder'
                      )}
                      color={hobbyTitleColor}
                      colorName="hobbyTitleColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Hobby Title Icon Color',
                        'cv-builder'
                      )}
                      color={hobbyTitleIconColor}
                      colorName="hobbyTitleIconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Hobby Title Background Color',
                        'cv-builder'
                      )}
                      color={hobbyTitleBgColor}
                      colorName="hobbyTitleBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Hobby Title Font Size',
                        'cv-builder'
                      )}
                      controlName={HOBBY_TITLE_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Hobby Title Icon Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        HOBBY_TITLE_ICON_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ColorControl
                      label={__(
                        'Hobby Name Color',
                        'cv-builder'
                      )}
                      color={hobbyNameColor}
                      colorName="hobbyNameColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Hobby Icon Color',
                        'cv-builder'
                      )}
                      color={hobbyIconColor}
                      colorName="hobbyIconColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Hobby Name Font Size',
                        'cv-builder'
                      )}
                      controlName={HOBBY_NAME_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Hobby Icon Font Size',
                        'cv-builder'
                      )}
                      controlName={HOBBY_ICON_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Hobby Item Gap',
                        'cv-builder'
                      )}
                      controlName={HOBBY_ITEM_GAP}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Padding',
                        'cv-builder'
                      )}
                      controlName={hobbyPaddingControl}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Border Radius',
                        'cv-builder'
                      )}
                      controlName={
                        hobbyBorderRadiusControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Hobby Section Padding',
                        'cv-builder'
                      )}
                      controlName={hobbySectionPadding}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Education',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Education Title Color',
                        'cv-builder'
                      )}
                      color={educationTitleColor}
                      colorName="educationTitleColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Education Title Icon Color',
                        'cv-builder'
                      )}
                      color={educationTitleIconColor}
                      colorName="educationTitleIconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Education Title Background Color',
                        'cv-builder'
                      )}
                      color={educationTitleBgColor}
                      colorName="educationTitleBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Education Title Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EDUCATION_TITLE_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Education Title Icon Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EDUCATION_TITLE_ICON_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ColorControl
                      label={__(
                        'Study Field Color',
                        'cv-builder'
                      )}
                      color={studyFieldColor}
                      colorName="studyFieldColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Degree Name Color',
                        'cv-builder'
                      )}
                      color={degreeNameColor}
                      colorName="degreeNameColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Institution, City and Country Name Color',
                        'cv-builder'
                      )}
                      color={institutionNameColor}
                      colorName="institutionNameColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Education Description Color',
                        'cv-builder'
                      )}
                      color={educationDescriptionColor}
                      colorName="educationDescriptionColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Education Passing Date Color',
                        'cv-builder'
                      )}
                      color={educationPassingDateColor}
                      colorName="educationPassingDateColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Study Field Font Size',
                        'cv-builder'
                      )}
                      controlName={STUDY_FIELD_FONT_SIZE}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Degree Name Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EDUCATION_DEGREE_NAME_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Institution, City, Country Name Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        INSTITUTION_CITY_COUNTRY_NAME_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Description Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EDUCATION_DESCRIPTION_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Passing Year Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EDUCATION_PASSING_YEAR_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Padding',
                        'cv-builder'
                      )}
                      controlName={
                        educationPaddingControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Border Radius',
                        'cv-builder'
                      )}
                      controlName={
                        educationBorderRadiusControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Education Section Padding',
                        'cv-builder'
                      )}
                      controlName={
                        educationSectionPadding
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Experience',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Experience Title Color',
                        'cv-builder'
                      )}
                      color={experienceTitleColor}
                      colorName="experienceTitleColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Experience Title Icon Color',
                        'cv-builder'
                      )}
                      color={experienceTitleIconColor}
                      colorName="experienceTitleIconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Experience Title Background Color',
                        'cv-builder'
                      )}
                      color={experienceTitleBgColor}
                      colorName="experienceTitleBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Title Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EXPERIENCE_TITLE_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Title Icon Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EXPERIENCE_TITLE_ICON_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Company Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EXPERIENCE_COMPANY_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Designation Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EXPERIENCE_DESIGNATION_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Date Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EXPERIENCE_DATE_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Description Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        EXPERIENCE_DESCRIPTION_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ColorControl
                      label={__(
                        'Company Name Color',
                        'cv-builder'
                      )}
                      color={companyNameColor}
                      colorName="companyNameColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Designation Color',
                        'cv-builder'
                      )}
                      color={experienceDesignationColor}
                      colorName="experienceDesignationColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Experience Description Color',
                        'cv-builder'
                      )}
                      color={experienceDescriptionColor}
                      colorName="experienceDescriptionColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Experience Date Color',
                        'cv-builder'
                      )}
                      color={experienceDateColor}
                      colorName="experienceDateColor"
                      onChange={setAttributes}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Padding',
                        'cv-builder'
                      )}
                      controlName={
                        experiencePaddingControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Border Radius',
                        'cv-builder'
                      )}
                      controlName={
                        experienceBorderRadiusControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Experience Section Padding',
                        'cv-builder'
                      )}
                      controlName={
                        experienceSectionPadding
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Reference',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Reference Title Color',
                        'cv-builder'
                      )}
                      color={referenceTitleColor}
                      colorName="referenceTitleColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Reference Title Icon Color',
                        'cv-builder'
                      )}
                      color={referenceTitleIconColor}
                      colorName="referenceTitleIconColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Reference Title Background Color',
                        'cv-builder'
                      )}
                      color={referenceTitleBgColor}
                      colorName="referenceTitleBgColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Reference Title Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        REFERENCE_TITLE_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Reference Title Icon Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        REFERENCE_TITLE_ICON_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ColorControl
                      label={__(
                        'Reference Name Color',
                        'cv-builder'
                      )}
                      color={referenceNameColor}
                      colorName="referenceNameColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Reference Job Position Color',
                        'cv-builder'
                      )}
                      color={referenceJobPositionColor}
                      colorName="referenceJobPositionColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Reference Company Color',
                        'cv-builder'
                      )}
                      color={referenceCompanyColor}
                      colorName="referenceCompanyColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Reference Phone Color',
                        'cv-builder'
                      )}
                      color={referencePhoneColor}
                      colorName="referencePhoneColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Reference Relation Color',
                        'cv-builder'
                      )}
                      color={referenceRelationColor}
                      colorName="referenceRelationColor"
                      onChange={setAttributes}
                    />
                    <ResRangleControl
                      label={__(
                        'Reference Name Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        REFERENCE_NAME_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Company Name Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        REFERENCE_COMPANY_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Job Position Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        REFERENCE_JOB_POSITION_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Phone Number Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        REFERENCE_PHONE_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResRangleControl
                      label={__(
                        'Reference Relation Font Size',
                        'cv-builder'
                      )}
                      controlName={
                        REFERENCE_RELATION_FONT_SIZE
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={1}
                      max={100}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Padding',
                        'cv-builder'
                      )}
                      controlName={
                        referencePaddingControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Title Border Radius',
                        'cv-builder'
                      )}
                      controlName={
                        referenceBorderRadiusControl
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                    <ResDimensionControl
                      label={__(
                        'Reference Section Padding',
                        'cv-builder'
                      )}
                      controlName={
                        referenceSectionPadding
                      }
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Cv Body',
                      'cv-builder'
                    )}
                    className=""
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Left Column Background Color',
                        'cv-builder'
                      )}
                      color={leftColumnBgColor}
                      colorName="leftColumnBgColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Right Column Background Color',
                        'cv-builder'
                      )}
                      color={rightColumnBgColor}
                      colorName="rightColumnBgColor"
                      onChange={setAttributes}
                    />
                    <ColorControl
                      label={__(
                        'Background Color',
                        'cv-builder'
                      )}
                      color={bodyBgColor}
                      colorName="bodyBgColor"
                      onChange={setAttributes}
                    />
                  </PanelBody>
                  <PanelBody
                    title={__(
                      'Footer',
                      'cv-builder'
                    )}
                    initialOpen={false}
                  >
                    <ColorControl
                      label={__(
                        'Background Color',
                        'cv-builder'
                      )}
                      color={footerBgColor}
                      colorName="footerBgColor"
                      onChange={setAttributes}
                    />
                    <ResDimensionControl
                      label={__(
                        'Footer Padding',
                        'cv-builder'
                      )}
                      controlName={footerPaddingControl}
                      objAttrs={objAttrs}
                      noUnits={false}
                      min={0}
                      max={1000}
                    />
                  </PanelBody>
                </Fragment>
              ),
            },
          ]}
        />
      </Fragment>
    </InspectorControls>
  );
};

export default Inspector;
